/* GPS Tail PDP — gallery, accordions, quantity, sticky bar, real Shopify add-to-cart. */
(function () {
  'use strict';

  var ROUTES = (window.Shopify && window.Shopify.routes) || {};
  var ADD_URL = (ROUTES.root || '/') + 'cart/add.js';
  var CART_URL = (ROUTES.root || '/') + 'cart';
  var DRAWER_SECTION = 'cart-drawer-section';

  function announce(root, message) {
    var region = root.querySelector('[ref="liveRegion"]');
    if (region) region.textContent = message;
  }

  function openCartDrawer() {
    var drawer = document.querySelector('theme-drawer#cart-drawer');
    if (!drawer) return false;
    if (typeof drawer.open === 'function') { drawer.open(); return true; }
    if (typeof drawer.show === 'function') { drawer.show(); return true; }
    var dialog = drawer.querySelector('dialog');
    if (dialog && typeof dialog.showModal === 'function') { dialog.showModal(); return true; }
    return false;
  }

  function refreshCartDrawer(sections) {
    var markup = sections && sections[DRAWER_SECTION];
    if (!markup) return;
    var host = document.getElementById('shopify-section-' + DRAWER_SECTION);
    if (!host) return;
    var parsed = new DOMParser().parseFromString(markup, 'text/html');
    var fresh = parsed.getElementById('shopify-section-' + DRAWER_SECTION) || parsed.body.firstElementChild;
    if (fresh) host.replaceWith(fresh);
  }

  function notifyTheme(item) {
    var detail = { source: 'gpst-pdp', item: item };
    ['cart:update', 'cart:refresh', 'variant:add'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: true }));
    });
    if (window.Shopify && typeof window.Shopify.onCartUpdate === 'function') {
      try { window.Shopify.onCartUpdate(); } catch (e) { /* noop */ }
    }
  }

  function wireAddToCart(root) {
    var form = root.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    form.addEventListener('submit', function (event) {
      if (form.dataset.gpstNative === 'true') return;
      event.preventDefault();
      event.stopImmediatePropagation();

      var buttons = Array.prototype.slice.call(document.querySelectorAll('.gpst-cta'));
      var labels = buttons.map(function (b) { return b.textContent; });
      buttons.forEach(function (b) { b.disabled = true; });
      announce(root, 'Adding to cart…');

      var body = new FormData(form);
      body.append('sections', DRAWER_SECTION);
      body.append('sections_url', window.location.pathname);

      fetch(ADD_URL, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw data;
            return data;
          });
        })
        .then(function (item) {
          refreshCartDrawer(item.sections);
          notifyTheme(item);
          announce(root, 'Added to cart.');
          if (!openCartDrawer()) { window.location.href = CART_URL; }
        })
        .catch(function (error) {
          var message = (error && (error.description || error.message)) || 'Could not add to cart.';
          announce(root, message);
          var slot = root.querySelector('[ref="addToCartTextError"]');
          if (slot) { slot.classList.remove('hidden'); slot.setAttribute('title', message); }
          if (!error || !error.description) {
            form.dataset.gpstNative = 'true';
            form.submit();
          }
        })
        .then(function () {
          buttons.forEach(function (b, i) { b.disabled = false; b.textContent = labels[i]; });
        });
    }, true);
  }

  function init(root) {
    if (!root || root.dataset.gpstReady === 'true') return;
    root.dataset.gpstReady = 'true';

    var gallery = root.querySelector('[data-gpst-gallery]');
    if (gallery) {
      var frames = Array.prototype.slice.call(gallery.querySelectorAll('[data-gpst-frame]'));
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gpst-thumb]'));
      var counter = gallery.querySelector('[data-gpst-counter]');
      var index = 0;
      var show = function (next) {
        if (!frames.length) return;
        index = (next + frames.length) % frames.length;
        frames.forEach(function (frame, i) {
          var active = i === index;
          frame.classList.toggle('is-active', active);
          if (active) { frame.removeAttribute('aria-hidden'); } else { frame.setAttribute('aria-hidden', 'true'); }
        });
        thumbs.forEach(function (thumb, i) {
          var active = i === index;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-current', active ? 'true' : 'false');
        });
        if (counter) counter.textContent = (index + 1) + ' / ' + frames.length;
      };
      thumbs.forEach(function (thumb, i) { thumb.addEventListener('click', function () { show(i); }); });
      var prev = gallery.querySelector('[data-gpst-prev]');
      var next = gallery.querySelector('[data-gpst-next]');
      if (prev) prev.addEventListener('click', function () { show(index - 1); });
      if (next) next.addEventListener('click', function () { show(index + 1); });
      gallery.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') { show(index - 1); }
        if (event.key === 'ArrowRight') { show(index + 1); }
      });
      var startX = null;
      var stage = gallery.querySelector('.gpst-gallery__stage');
      if (stage) {
        stage.addEventListener('touchstart', function (event) { startX = event.touches[0].clientX; }, { passive: true });
        stage.addEventListener('touchend', function (event) {
          if (startX === null) return;
          var delta = event.changedTouches[0].clientX - startX;
          if (Math.abs(delta) > 40) { show(delta < 0 ? index + 1 : index - 1); }
          startX = null;
        }, { passive: true });
      }
    }

    var qtyInput = root.querySelector('[data-gpst-qty-input]');
    if (qtyInput) {
      root.querySelectorAll('[data-gpst-qty]').forEach(function (button) {
        button.addEventListener('click', function () {
          var step = parseInt(qtyInput.getAttribute('step'), 10) || 1;
          var min = parseInt(qtyInput.getAttribute('min'), 10) || 1;
          var max = parseInt(qtyInput.getAttribute('max'), 10);
          var delta = parseInt(button.getAttribute('data-gpst-qty'), 10) * step;
          var value = (parseInt(qtyInput.value, 10) || min) + delta;
          if (value < min) value = min;
          if (!isNaN(max) && value > max) value = max;
          qtyInput.value = value;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    }

    root.querySelectorAll('[data-gpst-acc]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));
        trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (panel) { panel.hidden = expanded; }
      });
    });

    var sticky = root.querySelector('[data-gpst-sticky]');
    var buybox = root.querySelector('[data-gpst-buybox]');
    if (sticky && buybox) {
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { sticky.hidden = entry.isIntersecting; });
        }, { rootMargin: '-120px 0px 0px 0px' });
        observer.observe(buybox);
      } else {
        var onScroll = function () { sticky.hidden = window.scrollY < 620; };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }
    }

    wireAddToCart(root);
  }

  var boot = function () { document.querySelectorAll('[data-gpst-root]').forEach(init); };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
